// NIGHT-DIRECTSTAFF-2026-10-24 §7: the install prompt -- once, on a phone, when the browser offers install and the CRM is not already
// the installed app. "Not now" hides it on this device (kept per device; Settings -> The app still has Install).
import React, { useEffect, useState } from 'react';
import { canInstall, onInstallable, promptInstall, isStandalone } from './lib/pwa';

export const INSTALL_DISMISS_KEY = 'crm.installBanner.dismissed.v1';
export const INSTALL_COPY = 'Install TherapyLink on this phone: it opens full-screen like an app, keeps today\'s lists when you lose signal, and shows alerts.';
const readDismissed = () => { try { return window.localStorage.getItem(INSTALL_DISMISS_KEY) === '1'; } catch { return false; } };
const btn = (bg, fg) => ({ background: bg, color: fg, border: 0, borderRadius: 8, padding: '0 14px', minHeight: 44, fontSize: 13, fontWeight: 700, cursor: 'pointer' });

/** narrow: is this a phone-width screen (only there is the banner shown) */
export default function InstallBanner({ narrow = typeof window !== 'undefined' && window.innerWidth <= 768 }) {
  const [able, setAble] = useState(canInstall());
  const [gone, setGone] = useState(readDismissed());
  useEffect(() => onInstallable(setAble), []);
  if (!narrow || !able || gone || isStandalone()) return null;
  const dismiss = () => { try { window.localStorage.setItem(INSTALL_DISMISS_KEY, '1'); } catch { /* private window: hidden for now */ } setGone(true); };
  return (
    <div data-testid="install-banner" role="region" aria-label="Install the app" style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', padding: '10px 12px',
      margin: '0 0 12px', background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 10, fontSize: 13, color: '#0f172a' }}>
      <span style={{ flex: '1 1 200px', minWidth: 0 }}>{INSTALL_COPY}</span>
      <button className="nb" data-testid="install-banner-install" onClick={async () => { await promptInstall(); setAble(canInstall()); }} style={btn('#1d4ed8', 'white')}>Install</button>
      <button className="nb" data-testid="install-banner-dismiss" onClick={dismiss} style={btn('transparent', '#334155')}>Not now</button>
    </div>
  );
}
